module.exports = __webpack_public_path__ + "fonts/visuelt-pro-regular.5e60f275.woff2";